import * as yup from 'yup'

export const createBackOrderValidationSchema = yup.object().shape({
  sku: yup.string().required('SKU is required.'),
  qty: yup.string().required('Quantity is required.'),
})